import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { CourseListViewMode } from '@treneo/shared/constants';
import { DEFAULT_COURSE_LIST_VIEW_MODE } from '@treneo/shared/constants';

const COURSE_VIEW_MODE_PERSIST_KEY = 'treneo:user-course-view-mode';

type CourseViewModeState = {
  viewMode: CourseListViewMode;
};

type CourseViewModeActions = {
  setCourseViewMode: (viewMode: CourseListViewMode) => void;
};

const initialState: CourseViewModeState = {
  viewMode: DEFAULT_COURSE_LIST_VIEW_MODE
};

export const useCourseViewModeStore = create<CourseViewModeState & CourseViewModeActions>()(
  persist(
    set => ({
      ...initialState,
      setCourseViewMode: viewMode => set({ viewMode })
    }),
    { name: COURSE_VIEW_MODE_PERSIST_KEY, partialize: state => ({ viewMode: state.viewMode }) }
  )
);

export const getCourseViewMode = (): CourseListViewMode =>
  useCourseViewModeStore.getState().viewMode;

export const setCourseViewMode = (viewMode: CourseListViewMode): void =>
  useCourseViewModeStore.getState().setCourseViewMode(viewMode);
